module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2834bea0cc1c121d71869d7e3b08de99.png";